import { BaseInputFilter } from "domain/models/base-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { TripsheetReport } from "domain/entities/tripsheet-report";
import { ITripsheetReportRepository } from "domain/contracts/tripsheet-report.contract";

class TripsheetReportRepository implements ITripsheetReportRepository {

  async getTripsheetReport(id: string, filter?: BaseInputFilter): Promise<Message<TripsheetReport>> {
    const response = await httpClient.get(`/reportKm/${id}`, { params: filter });
    return response.data;
  }
  
}

export default new TripsheetReportRepository();
